import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { Link, TableCell } from '@mui/material';

/**
 * A value naming a row of another grid — the payin or payout a Telegram message
 * decided — linked to that grid, which opens searching for it: GridPageAbstract
 * runs the `searchValue` the link carries as its search, shown in the search box
 * and cleared from there. The head field's `linkTo` is the grid's path
 * (`/app/payin-instances`), and its search must cover the value.
 */
export default class GridLinkCell extends React.Component {
    render() {
        const { id, linkTo } = this.props.field;
        const { value } = this.props;
        const baseStyle = this.props.styles;

        return (
            <TableCell key={id} align="left" sx={{ ...baseStyle }}>
                {value ? (
                    <Link
                        component={RouterLink}
                        to={linkTo}
                        state={{ searchValue: String(value) }}
                        variant="body2"
                        // An identifier: one line, as GridTextCell keeps one.
                        sx={{ whiteSpace: 'nowrap' }}
                        // Not a click on the row as well, on grids where that does something.
                        onClick={(event) => event.stopPropagation()}
                    >
                        {value}
                    </Link>
                ) : null}
            </TableCell>
        );
    }
}
